"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var systems_json_1 = __importDefault(require("../../assets/systems.json"));
/**
 * Find a system by name or ESI ID. `Error` is thrown upon no match.
 * @param {object} search - Search object containing the key to search by
 * (`name` or `id`) and the search string as the corresponding value. Exactly
 * one search property must be provided. Example: `{ name: "Jita" }`
 * @returns {System} Star system data.
 */
exports.default = (function (search) {
    var keys = Object.keys(search);
    if (keys.length !== 1) {
        throw new Error("Search object must contain exactly one property.");
    }
    var searchKey = keys[0];
    if (!["name", "id"].includes(searchKey)) {
        throw new Error("Invalid search key.");
    }
    var searchValue = Object.values(search)[0];
    var match = systems_json_1.default.find(function (system) { return system[searchKey] === searchValue; });
    if (!match) {
        throw new Error("System not found.");
    }
    return match;
});
